export interface SocialMediaUserData {
  firstName: string;
  lastName: string;
  street: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  phone: string;
  nick: string;
  birthday: string;
  gender: number;
  preferredCinemaId: string;
  agreements: string[];
}
